import { s } from "../../../../utilities/common"

export const PlaylistsIcon = () => (
  <svg
    width={s("40")}
    height={s("40")}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.2539 4.80527C18.5 4.72323 18.8008 4.77792 19.0195 4.94198C19.2382 5.10605 19.375 5.35219 19.375 5.62558V7.37558C19.3749 7.78562 19.1015 8.11388 18.7461 8.22323L16.75 8.8248V16.5631C16.7498 17.7934 15.3554 18.7506 13.6875 18.7506C11.9923 18.7506 10.6252 17.7934 10.625 16.5631C10.625 15.3326 11.9922 14.3756 13.6875 14.3756C14.125 14.3756 14.5625 14.4303 15 14.5943V6.41855C15 6.03576 15.2461 5.68029 15.6016 5.57089L18.2539 4.80527ZM12.5195 10.5006C12.7109 10.5006 12.875 10.6646 12.875 10.856V11.9225C12.8748 12.1137 12.7108 12.2506 12.5195 12.2506H5.32812C5.13683 12.2506 5.00016 12.1137 5 11.9225V10.856C5 10.6646 5.13672 10.5006 5.32812 10.5006H12.5195ZM12.5986 7.00058C12.7393 7.00064 12.8799 7.21936 12.8799 7.43808V8.31308C12.8798 8.55897 12.7393 8.75052 12.5986 8.75058H5.28125C5.1231 8.75043 5.00011 8.55892 5 8.31308V7.43808C5 7.21941 5.12303 7.00074 5.28125 7.00058H12.5986Z"
      fill="#BFBFBF"
    />
  </svg>
)
